import { ReduxRootState } from 'types'

export const selectAppLoading = (state: ReduxRootState) => state.ui.isAppLoading

export const selectIsNavigationOpen = (state: ReduxRootState) =>
  state.ui.navigation.isOpen

export const selectToasts = (state: ReduxRootState) => state.ui.toasts
